import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { withTranslation } from "react-i18next";
import EMPDialog from "../shared/components/EMPDialog/EMPDialog";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";

const ErrorScreen = (props) => {
  const handleLoginBack = () => {
    AuthenticationFailureHandler.execute();
  };

  const titleKey = props.titleKey || "common.error";
  const errorMessageKey =
    props.errorMessageKey || "ErrorPopupScreen.errorMessage";
  const buttonTextKey = props.buttonTextKey || "ErrorPopupScreen.buttonText";

  return (
    <EMPDialog
      open
      dialogTitle={props.t(titleKey)}
      hasActionButton
      actionButtonText={props.t(buttonTextKey)}
      onConfirm={handleLoginBack}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Typography variant="body1" data-testid="alert-dialog-description">
        {props.t(errorMessageKey)}
      </Typography>
    </EMPDialog>
  );
};

ErrorScreen.propTypes = {
  titleKey: PropTypes.string,
  errorMessageKey: PropTypes.string,
  buttonTextKey: PropTypes.string,
  t: PropTypes.func.isRequired,
};

ErrorScreen.defaultProps = {
  titleKey: "common.error",
  errorMessageKey: "ErrorPopupScreen.errorMessage",
  buttonTextKey: "ErrorPopupScreen.buttonText",
};

export default withTranslation("emp")(ErrorScreen);
